import { render, staticRenderFns } from "./StatusTag.vue?vue&type=template&id=547ceba4&scoped=true&"
import script from "./StatusTag.vue?vue&type=script&lang=js&"
export * from "./StatusTag.vue?vue&type=script&lang=js&"
import style0 from "./StatusTag.vue?vue&type=style&index=0&id=547ceba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547ceba4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2983364112/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('547ceba4')) {
      api.createRecord('547ceba4', component.options)
    } else {
      api.reload('547ceba4', component.options)
    }
    module.hot.accept("./StatusTag.vue?vue&type=template&id=547ceba4&scoped=true&", function () {
      api.rerender('547ceba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/StatusTag.vue"
export default component.exports